/**
 * AJAX фильтрация для блока Taxonomy Filter
 *
 * Конфиг: wallcoverTaxonomyFilter (отдельно от wallcoverData — иначе на странице с search и др.
 * последний wp_localize_script перезаписывает wallcoverData и пропадают taxonomyFilterRestUrl/restNonce).
 */
let taxonomyFilterTransport = null;

document.addEventListener('DOMContentLoaded', function () {
	if (typeof wallcoverTaxonomyFilter !== 'undefined') {
		taxonomyFilterTransport = wallcoverTaxonomyFilter;
	} else if (typeof wallcoverData !== 'undefined') {
		taxonomyFilterTransport = wallcoverData;
	} else {
		taxonomyFilterTransport = {
			ajaxUrl: '/wp-admin/admin-ajax.php',
			nonce: '',
		};
	}

	const apiLink = document.querySelector('link[rel="https://api.w.org/"]');
	if (
		!taxonomyFilterTransport.taxonomyFilterRestUrl &&
		apiLink &&
		apiLink.href
	) {
		const root = apiLink.href.replace(/\/?$/, '/');
		taxonomyFilterTransport.taxonomyFilterRestUrl = root + 'wallcover/v1/taxonomy-filter';
	}

	const filterBlocks = document.querySelectorAll('.wp-block-wallcover-taxonomy-filter');

	filterBlocks.forEach(filterBlock => {
		initTaxonomyFilter(filterBlock);
	});

	// Инициализируем обработчики пагинации для всех Query Loop блоков на странице
	const queryLoopBlocks = document.querySelectorAll('.wp-block-query');
	queryLoopBlocks.forEach(queryLoopBlock => {
		// Находим соответствующий фильтр для этого Query Loop
		const filterBlock = findFilterForQueryLoop(queryLoopBlock);
		if (filterBlock) {
			const taxonomy = filterBlock.dataset.taxonomy;
			const loadingElement = filterBlock.querySelector('.filter-loading');

			// Инициализируем обработчики кликов
			initPaginationHandlers(taxonomy, queryLoopBlock, loadingElement, filterBlock);
		}
	});
});

function initTaxonomyFilter(filterBlock) {
	const taxonomy = filterBlock.dataset.taxonomy;
	const layout = filterBlock.dataset.layout;
	const loadingElement = filterBlock.querySelector('.filter-loading');

	// Находим ближайший Query Loop блок
	const queryLoopBlock = findQueryLoopBlock(filterBlock);
	if (!queryLoopBlock) {
		console.warn('Query Loop block not found for taxonomy filter');
		return;
	}

	if (layout === 'dropdown') {
		const dropdown = filterBlock.querySelector('.taxonomy-filter-dropdown');
		if (dropdown) {
			dropdown.addEventListener('change', function (e) {
				const termSlug = e.target.value;
				filterPosts(taxonomy, termSlug, queryLoopBlock, loadingElement, 1);
				updateActiveState(filterBlock, termSlug);
			});
		}
	} else {
		const filterLinks = filterBlock.querySelectorAll('.filter-link');
		filterLinks.forEach(link => {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				const termSlug = this.dataset.termSlug;
				filterPosts(taxonomy, termSlug, queryLoopBlock, loadingElement, 1);
				updateActiveState(filterBlock, termSlug);
			});
		});
	}
}

function findQueryLoopBlock(filterBlock) {
	// Ищем Query Loop в том же контейнере
	let container = filterBlock.parentElement;
	let queryLoop = null;

	// Поиск в родительских элементах
	while (container && !queryLoop) {
		queryLoop = container.querySelector('.wp-block-query');
		if (!queryLoop) {
			container = container.parentElement;
		}
	}

	// Если не найден, ищем на всей странице
	if (!queryLoop) {
		queryLoop = document.querySelector('.wp-block-query');
	}

	return queryLoop;
}

function findFilterForQueryLoop(queryLoopBlock) {
	// Ищем фильтр в том же контейнере
	let container = queryLoopBlock.parentElement;
	let filter = null;

	// Поиск в родительских элементах
	while (container && !filter) {
		filter = container.querySelector('.wp-block-wallcover-taxonomy-filter');
		if (!filter) {
			container = container.parentElement;
		}
	}

	// Если не найден, ищем на всей странице
	if (!filter) {
		filter = document.querySelector('.wp-block-wallcover-taxonomy-filter');
	}

	return filter;
}

function applyTaxonomyFilterPayload(queryLoopBlock, taxonomy, termSlug, page, payload) {
	const postTemplate = queryLoopBlock.querySelector('.wp-block-post-template');
	if (postTemplate) {
		postTemplate.outerHTML = payload.html;
	} else {
		queryLoopBlock.innerHTML = payload.html;
	}

	if (payload.pagination) {
		updatePagination(queryLoopBlock, payload.pagination, taxonomy, termSlug);
	}

	const newUrl = new URL(window.location.href);
	if (termSlug) {
		newUrl.searchParams.set(taxonomy, termSlug);
	} else {
		newUrl.searchParams.delete(taxonomy);
	}
	if (page && page > 1) {
		newUrl.searchParams.set('paged', page);
	} else {
		newUrl.searchParams.delete('paged');
	}
	window.history.pushState({}, '', newUrl.toString());

	document.dispatchEvent(
		new CustomEvent('taxonomyFilterChanged', {
			detail: {
				taxonomy,
				termSlug,
				queryLoopBlock,
				foundPosts: payload.found_posts,
			},
		})
	);
}

function filterPosts(taxonomy, termSlug, queryLoopBlock, loadingElement, page) {
	if (loadingElement) {
		loadingElement.style.display = 'block';
	}
	queryLoopBlock.classList.add('is-loading');

	const queryStructure = extractQueryLoopStructure(queryLoopBlock);

	const tf = taxonomyFilterTransport || {};

	let ajaxUrl = '/wp-admin/admin-ajax.php';
	if (tf.ajaxUrl) {
		ajaxUrl = tf.ajaxUrl;
	} else if (typeof window.ajaxurl !== 'undefined') {
		ajaxUrl = window.ajaxurl;
	}

	const runAjax = () => {
		const formData = new FormData();
		formData.append('action', 'taxonomy_filter');
		formData.append('taxonomy', taxonomy);
		formData.append('term_slug', termSlug || '');
		formData.append('current_url', window.location.href);
		formData.append('query_structure', JSON.stringify(queryStructure));
		formData.append('paged', page || 1);
		if (tf.nonce) {
			formData.append('nonce', tf.nonce);
		}
		if (tf.isUserLoggedIn !== undefined) {
			formData.append('user_logged_in', tf.isUserLoggedIn ? '1' : '0');
		}
		return fetch(ajaxUrl, {
			method: 'POST',
			body: formData,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				if (data.success && data.data && typeof data.data.html === 'string') {
					applyTaxonomyFilterPayload(queryLoopBlock, taxonomy, termSlug, page, data.data);
				} else {
					throw new Error(data.data || 'Filter request failed');
				}
			});
	};

	const handleError = (error) => {
		console.error('Filter error:', error);
		if (loadingElement) {
			loadingElement.innerHTML =
				'<div class="filter-error">Ошибка загрузки. Попробуйте обновить страницу.</div>';
			setTimeout(() => {
				loadingElement.style.display = 'none';
			}, 3000);
		}
		const fallbackUrl = new URL(window.location.href);
		if (termSlug) {
			fallbackUrl.searchParams.set(taxonomy, termSlug);
		} else {
			fallbackUrl.searchParams.delete(taxonomy);
		}
		if (error.name !== 'TypeError' && !error.message.includes('security')) {
			setTimeout(() => {
				window.location.href = fallbackUrl.toString();
			}, 3000);
		}
	};

	const clearLoading = () => {
		if (loadingElement) {
			loadingElement.style.display = 'none';
		}
		queryLoopBlock.classList.remove('is-loading');
	};

	const restUrl = tf.taxonomyFilterRestUrl;
	const restNonce = tf.restNonce;

	if (restUrl && restNonce) {
		fetch(restUrl, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-WP-Nonce': restNonce,
			},
			body: JSON.stringify({
				taxonomy,
				term_slug: termSlug || '',
				current_url: window.location.href,
				query_structure: queryStructure,
				paged: page || 1,
				security: tf.nonce || '',
			}),
		})
			.then(async (response) => {
				let body = {};
				try {
					body = await response.json();
				} catch (e) {
					body = {};
				}
				if (!response.ok) {
					throw new Error(body.message || 'REST taxonomy filter error');
				}
				return body;
			})
			.then((body) => {
				if (body && typeof body.html === 'string') {
					applyTaxonomyFilterPayload(queryLoopBlock, taxonomy, termSlug, page, body);
					return;
				}
				throw new Error('REST bad body');
			})
			.catch(() => runAjax())
			.catch(handleError)
			.finally(clearLoading);
		return;
	}

	runAjax().catch(handleError).finally(clearLoading);
}

function updateActiveState(filterBlock, activeTermSlug) {
	const layout = filterBlock.dataset.layout;

	if (layout === 'dropdown') {
		const dropdown = filterBlock.querySelector('.taxonomy-filter-dropdown');
		if (dropdown) {
			dropdown.value = activeTermSlug || '';
		}
	} else {
		// Убираем активный класс со всех элементов
		const filterItems = filterBlock.querySelectorAll('.filter-item');
		filterItems.forEach(item => item.classList.remove('active'));

		// Добавляем активный класс к выбранному элементу
		const activeLink = filterBlock.querySelector(`[data-term-slug="${activeTermSlug || ''}"]`);
		if (activeLink) {
			activeLink.closest('.filter-item').classList.add('active');
		}
	}
}

/**
 * Извлекает структуру Query Loop блока для воспроизведения в AJAX
 */
function extractQueryLoopStructure(queryLoopBlock) {
	const structure = {
		classes: queryLoopBlock.className,
		layout: 'grid', // по умолчанию
		columns: 1,
		hasTitle: false,
		hasExcerpt: false,
		hasDate: false,
		hasFeaturedImage: false,
		hasTerms: false,
		hasPagination: false,
		postTemplate: null
	};

	// Определяем layout
	if (queryLoopBlock.classList.contains('is-layout-grid')) {
		structure.layout = 'grid';
	} else if (queryLoopBlock.classList.contains('is-layout-flex')) {
		structure.layout = 'flex';
	}

	// Ищем Post Template
	const postTemplate = queryLoopBlock.querySelector('.wp-block-post-template');
	if (postTemplate) {
		structure.postTemplate = {
			classes: postTemplate.className,
			innerHTML: postTemplate.innerHTML
		};

		// Определяем количество колонок из CSS grid
		const computedStyle = window.getComputedStyle(postTemplate);
		const gridTemplateColumns = computedStyle.gridTemplateColumns;
		if (gridTemplateColumns && gridTemplateColumns !== 'none') {
			structure.columns = gridTemplateColumns.split(' ').length;
		}

		// Проверяем наличие различных блоков
		structure.hasTitle = postTemplate.querySelector('.wp-block-post-title') !== null;
		structure.hasExcerpt = postTemplate.querySelector('.wp-block-post-excerpt') !== null;
		structure.hasDate = postTemplate.querySelector('.wp-block-post-date') !== null;
		structure.hasFeaturedImage = postTemplate.querySelector('.wp-block-post-featured-image') !== null;
		structure.hasTerms = postTemplate.querySelector('.wp-block-post-terms') !== null;
	}

	// Проверяем наличие пагинации
	structure.hasPagination = queryLoopBlock.querySelector('.wp-block-query-pagination') !== null;

	return structure;
}

/**
 * Инициализирует обработчики кликов по пагинации
 */
function initPaginationHandlers(taxonomy, queryLoopBlock, loadingElement, filterBlock) {
	// Используем делегирование событий для динамически добавляемых элементов пагинации
	queryLoopBlock.addEventListener('click', function (e) {
		// Ищем ссылку пагинации по стандартным WordPress классам
		const paginationLink = e.target.closest('.page-numbers, .wp-block-query-pagination-previous, .wp-block-query-pagination-next');

		// Пропускаем если это не ссылка или это текущая страница
		if (!paginationLink || paginationLink.tagName !== 'A' || paginationLink.classList.contains('current')) {
			return;
		}

		e.preventDefault();

		const href = paginationLink.getAttribute('href');
		let page = '1';

		// Извлекаем номер страницы из URL
		// Формат 1: ?paged=2
		let match = href.match(/[?&]paged=(\d+)/);
		if (match) {
			page = match[1];
		} else {
			// Формат 2: /page/2/ или /page/2
			match = href.match(/\/page\/(\d+)\/?/);
			if (match) {
				page = match[1];
			}
		}

		// Получаем текущий активный терм
		const activeTermSlug = getCurrentActiveTermSlug(filterBlock);

		// Загружаем посты для указанной страницы
		filterPosts(taxonomy, activeTermSlug, queryLoopBlock, loadingElement, parseInt(page));
	});
}

/**
 * Получает номер текущей страницы из URL
 */
function getCurrentPageFromUrl() {
	// Сначала проверяем параметр ?paged=N
	const urlParams = new URLSearchParams(window.location.search);
	const pagedParam = urlParams.get('paged');
	if (pagedParam) {
		return parseInt(pagedParam);
	}

	// Затем проверяем формат /page/N/
	const pathMatch = window.location.pathname.match(/\/page\/(\d+)\/?/);
	if (pathMatch) {
		return parseInt(pathMatch[1]);
	}

	// По умолчанию первая страница
	return 1;
}

/**
 * Получает текущий активный терм из фильтра
 */
function getCurrentActiveTermSlug(filterBlock) {
	const layout = filterBlock.dataset.layout;

	if (layout === 'dropdown') {
		const dropdown = filterBlock.querySelector('.taxonomy-filter-dropdown');
		return dropdown ? dropdown.value : '';
	} else {
		const activeItem = filterBlock.querySelector('.filter-item.active .filter-link');
		return activeItem ? activeItem.dataset.termSlug : '';
	}
}

function updatePagination(queryLoopBlock, paginationData, taxonomy, termSlug) {
	const pagination = queryLoopBlock.querySelector('.wp-block-query-pagination');
	if (!pagination) return;

	const { current_page, max_pages } = paginationData;

	// Если только одна страница, скрываем пагинацию
	if (max_pages <= 1) {
		pagination.style.display = 'none';
		return;
	} else {
		pagination.style.display = '';
	}

	// Обновляем кнопку "Previous"
	const prevButton = pagination.querySelector('.wp-block-query-pagination-previous');
	if (prevButton) {
		if (current_page > 1) {
			prevButton.style.display = '';
			prevButton.href = updateUrlWithParams(current_page - 1, taxonomy, termSlug);
		} else {
			prevButton.style.display = 'none';
		}
	} else if (current_page > 1) {
		// Если кнопки Previous нет, но она нужна - создаем её
		const prevButton = document.createElement('a');
		prevButton.className = 'wp-block-query-pagination-previous';
		prevButton.href = updateUrlWithParams(current_page - 1, taxonomy, termSlug);
		prevButton.textContent = 'Back';
		pagination.insertBefore(prevButton, pagination.firstChild);
	}

	// Обновляем кнопку "Next"
	const nextButton = pagination.querySelector('.wp-block-query-pagination-next');
	if (nextButton) {
		if (current_page < max_pages) {
			nextButton.style.display = '';
			nextButton.href = updateUrlWithParams(current_page + 1, taxonomy, termSlug);
		} else {
			nextButton.style.display = 'none';
		}
	} else if (current_page < max_pages) {
		// Если кнопки Next нет, но она нужна - создаем её
		const nextButton = document.createElement('a');
		nextButton.className = 'wp-block-query-pagination-next';
		nextButton.href = updateUrlWithParams(current_page + 1, taxonomy, termSlug);
		nextButton.textContent = 'Next';
		pagination.appendChild(nextButton);
	}

	// Обновляем номера страниц
	const numbersContainer = pagination.querySelector('.wp-block-query-pagination-numbers');
	if (numbersContainer) {
		updatePaginationNumbers(numbersContainer, current_page, max_pages, taxonomy, termSlug);
	}
}

function updatePaginationNumbers(container, currentPage, maxPages, taxonomy, termSlug) {
	// Очищаем существующие номера
	container.innerHTML = '';

	// Определяем диапазон страниц для показа
	const startPage = Math.max(1, currentPage - 2);
	const endPage = Math.min(maxPages, currentPage + 2);

	// Показываем первую страницу если нужно
	if (startPage > 1) {
		const firstLink = createPageLink(1, taxonomy, termSlug);
		container.appendChild(firstLink);

		if (startPage > 2) {
			const dots = document.createElement('span');
			dots.className = 'page-numbers dots';
			dots.textContent = '…';
			container.appendChild(dots);
		}
	}

	// Показываем страницы в диапазоне
	for (let i = startPage; i <= endPage; i++) {
		if (i === currentPage) {
			const currentSpan = document.createElement('span');
			currentSpan.className = 'page-numbers current';
			currentSpan.setAttribute('aria-current', 'page');
			currentSpan.textContent = i;
			container.appendChild(currentSpan);
		} else {
			const pageLink = createPageLink(i, taxonomy, termSlug);
			container.appendChild(pageLink);
		}
	}

	// Показываем последнюю страницу если нужно
	if (endPage < maxPages) {
		if (endPage < maxPages - 1) {
			const dots = document.createElement('span');
			dots.className = 'page-numbers dots';
			dots.textContent = '…';
			container.appendChild(dots);
		}

		const lastLink = createPageLink(maxPages, taxonomy, termSlug);
		container.appendChild(lastLink);
	}
}

function createPageLink(pageNumber, taxonomy, termSlug) {
	const link = document.createElement('a');
	link.className = 'page-numbers';
	link.href = updateUrlWithParams(pageNumber, taxonomy, termSlug);
	link.textContent = pageNumber;
	return link;
}

function updateUrlWithParams(page, taxonomy, termSlug) {
	const url = new URL(window.location.href);

	if (page > 1) {
		url.searchParams.set('paged', page);
	} else {
		url.searchParams.delete('paged');
	}

	if (termSlug) {
		url.searchParams.set(taxonomy, termSlug);
	} else {
		url.searchParams.delete(taxonomy);
	}

	return url.toString();
} 